import _ from 'lodash';
import ah from '../utils/ajax-helper'; // get message type list

export var getMessageEventTypeList = function getMessageEventTypeList(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/message/event/type/list"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // edit message type list

export var editMessageTypeAPI = function editMessageTypeAPI(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var messageTypeList = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/message/event/type/edit"), JSON.stringify(messageTypeList), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get message list

export var getMessageEventList = function getMessageEventList(contextRoot, noProgress) {
  var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sort = arguments.length > 3 ? arguments[3] : undefined;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var external = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'beginTime';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      external: external,
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      keyword: keyword,
      isPublished: false,
      includeNotBegined: true
    };
    ah.get("".concat(contextRoot, "/message/event/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get message published

export var getMessageEventListPublished = function getMessageEventListPublished(contextRoot, noProgress) {
  var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sort = arguments.length > 3 ? arguments[3] : undefined;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'beginTime';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      isPublished: true,
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      keyword: keyword,
      includeNotBegined: true
    };
    ah.get("".concat(contextRoot, "/message/event/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get message published and not end

export var getMessageListNotEnd = function getMessageListNotEnd(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Promise(function (resolve, reject) {
    var parameters = {
      isShowLive: true,
      offset: 0,
      limit: null,
      sort: 'endTime:desc',
      keyword: null
    }; // ah.get(`${contextRoot}/message/event/list`, parameters, null, noProgress).then(result => {
    //     if(result.code < 0)
    //         throw new Error(result.error)
    //     resolve(result.data)
    // }).catch(error => {
    //     reject(error)
    // })

    ah.get("".concat(contextRoot, "/billboard/list"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // create message

export var createMessageAPI = function createMessageAPI(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var messageData = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/message/create"), JSON.stringify(messageData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // edit message

export var editMessageAPI = function editMessageAPI(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var messageData = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/message/edit"), JSON.stringify(messageData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // delete message

export var deleteMessageAPI = function deleteMessageAPI(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var messageData = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/message/delete"), JSON.stringify(messageData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // handle publish status

export var editMessagePublishStatusAPI = function editMessagePublishStatusAPI(contextRoot) {
  var noProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var messageData = arguments.length > 2 ? arguments[2] : undefined;
  var isPublished = arguments.length > 3 ? arguments[3] : undefined;
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/message/isPublished/").concat(isPublished), JSON.stringify(messageData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
};